import { Anchor, Container, Paper, Stack, Text, Title } from '@mantine/core';

export function ContactPage() {
  return <Container size="sm" py="xl"><Paper withBorder p="xl"><Stack><Title order={1}>Contact</Title><Text c="dimmed">Questions, feedback, or an idea for Page Outil? Get in touch with Anthony.</Text><Anchor href="mailto:email@anthonydeguzman.com">email@anthonydeguzman.com</Anchor></Stack></Paper></Container>;
}
